/* OfeelE 2.0 — app.js (vanilla, no deps) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function money(cents) {
    return '₪' + (cents / 100).toLocaleString('he-IL', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Drawers ---------- */
  function openDrawer(id) { var d = $(id); if (!d) return; d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(el) { var d = el.closest('.drawer, .popup'); if (!d) return; d.classList.remove('is-open'); document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open]');
    if (t) { e.preventDefault(); openDrawer(t.getAttribute('data-open')); return; }
    var c = e.target.closest('[data-close], .drawer__overlay, .popup__overlay');
    if (c) { e.preventDefault(); closeDrawer(c); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.drawer.is-open, .popup.is-open').forEach(function (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }); });

  /* ---------- Cart + STYLE CODE gift ---------- */
  var STYLE_GUIDE_VARIANT_ID = 51596090736955;
  var STYLE_GUIDE_THRESHOLD = 34900;
  var styleGuideSyncing = false;
  var STYLE_GUIDE_TEE_PRODUCTS = [10320812245307, 10320812671291, 10320812704059];

  function syncStyleGuideGift() {
    if (styleGuideSyncing) return Promise.resolve();
    styleGuideSyncing = true;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var guideTotal = cart.items.reduce(function (total, item) {
          return Number(item.variant_id) === STYLE_GUIDE_VARIANT_ID ? total + item.final_line_price : total;
        }, 0);
        var qualifyingTotal = Math.max(0, cart.total_price - guideTotal);
        var guide = cart.items.filter(function (item) { return Number(item.variant_id) === STYLE_GUIDE_VARIANT_ID; })[0];
        var autoGift = cart.items.filter(function (item) {
          return Number(item.variant_id) === STYLE_GUIDE_VARIANT_ID && item.properties && item.properties._ofeele_gift === 'true';
        })[0];

        var hasTee = cart.items.some(function (item) { return STYLE_GUIDE_TEE_PRODUCTS.indexOf(Number(item.product_id)) > -1; });
        var qualifies = hasTee || qualifyingTotal >= STYLE_GUIDE_THRESHOLD;
        if (qualifies && !guide) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: STYLE_GUIDE_VARIANT_ID, quantity: 1, properties: { _ofeele_gift: 'true', 'קישור להורדת הספר': 'https://ofeelrockart.com/pages/book' } }] })
          }).then(function (r) { if (!r.ok) throw r; return r.json(); })
            .then(function () { return fetch('/cart.js').then(function(r) { return r.json(); }); })
            .then(function (withGift) {
              var activeCodes = (cart.discount_codes || []).filter(function(d) { return d.applicable; });
              var keptCodes = (withGift.discount_codes || []).filter(function(d) { return d.applicable; });
              var lostCode = activeCodes.some(function(d) { return !keptCodes.some(function(k) { return k.code.toLowerCase() === d.code.toLowerCase(); }); });
              var addedGift = withGift.items.filter(function(i) { return Number(i.variant_id) === STYLE_GUIDE_VARIANT_ID && i.properties && i.properties._ofeele_gift === 'true'; })[0];
              if (addedGift && (lostCode || addedGift.final_line_price > 0)) {
                return fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:addedGift.key,quantity:0})});
              }
            });
        }
        if (!qualifies && autoGift) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: autoGift.key, quantity: 0 })
          });
        }
      })
      .catch(function () {})
      .then(function () { styleGuideSyncing = false; });
  }

  function refreshCartDrawer(open) {
    return syncStyleGuideGift()
      .then(function () { return fetch(window.location.pathname + '?section_id=' + (document.querySelector('.lp-backstrip') ? 'cart-drawer-beauty' : 'cart-drawer')); })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        var cur = $('#CartDrawer');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
        var cnt = tmp.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach(function (el) { if (cnt) el.textContent = cnt.textContent; });
        if (open) openDrawer('#CartDrawerWrap');
        var main = document.querySelector('[data-ofeele-main-cart]');
        if (main) return fetch(window.location.pathname + '?section_id=main-cart')
          .then(function (r) { return r.text(); })
          .then(function (markup) {
            var fragment = document.createElement('div'); fragment.innerHTML = markup;
            var next = fragment.querySelector('[data-ofeele-main-cart]');
            if (next) main.innerHTML = next.innerHTML;
          });
      });
  }
  window.OfeeleCart = { refresh: refreshCartDrawer };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'מוסיף...';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return refreshCartDrawer(true); })
      .catch(function () { toast('המוצר אזל או שגיאה זמנית — נסי שוב'); })
      .then(function () { btn.disabled = false; btn.textContent = orig; });
  });

  document.addEventListener('click', function (e) {
    var chg = e.target.closest('[data-qty-change]');
    if (chg) {
      e.preventDefault();
      var line = chg.getAttribute('data-line');
      var qty = parseInt(chg.getAttribute('data-qty-change'), 10);
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: parseInt(line, 10), quantity: qty }) })
        .then(function () { return refreshCartDrawer(false); });
    }
  });


  /* Coupon entry before checkout keeps the shipping gap based on the discounted cart. */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-ofeele-discount-form]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('button[type=submit]');
    var status = form.querySelector('[data-ofeele-discount-status]');
    var code = form.querySelector('[name=discount]').value.trim();
    button.disabled = true;
    status.textContent = 'מעדכנת את הסל…';
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var gift = cart.items.filter(function(i) { return Number(i.variant_id) === STYLE_GUIDE_VARIANT_ID && i.properties && i.properties._ofeele_gift === 'true'; })[0];
      if (gift) return fetch('/cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:gift.key,quantity:0})});
    }).then(function() {
      return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
        method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({discount:code})
      });
    }).then(function(r) { if (!r.ok) throw new Error('discount'); return r.json(); })
      .then(function(cart) {
        if (code && !(cart.discount_codes || []).some(function(d) { return d.applicable; })) {
          status.textContent = 'הקוד אינו תקף למוצרים שבסל. בדקי את הקוד ותנאי ההטבה.';
          return refreshCartDrawer(false).then(function() { toast('הקוד אינו תקף למוצרים שבסל'); });
        }
        return refreshCartDrawer(false).then(function() { toast(code ? 'הקוד הוחל והסכום עודכן' : 'קוד הקופון הוסר'); });
      }).catch(function() { status.textContent = 'לא הצלחנו לעדכן את הקוד. נסי שוב.'; })
      .then(function() { button.disabled = false; });
  });
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="/checkout"]');
    if (!link || !link.closest('#CartDrawer, [data-ofeele-main-cart]')) return;
    e.preventDefault();
    syncStyleGuideGift().then(function() { window.location.href = link.href; });
  });

  /* ---------- Variant picker ---------- */
  $$('[data-product-form]').forEach(function (wrap) {
    var dataEl = $('[data-product-json]', wrap);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = $('input[name="id"]', wrap);
    var priceEl = $('[data-price]', wrap);
    var cmpEl = $('[data-compare-price]', wrap);
    var offEl = $('[data-off]', wrap);
    var atc = $('[data-atc]', wrap);
    var stickyPrice = $('[data-sticky-price]');

    function selectedOptions() {
      return $$('.opt', wrap).map(function (o) {
        var checked = $('input:checked', o);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }
    function update() {
      var v = findVariant(selectedOptions());
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (cmpEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false;
          if (offEl) { offEl.hidden = false; offEl.textContent = Math.round(100 - v.price * 100 / v.compare_at_price) + '% הנחה'; }
        } else { cmpEl.hidden = true; if (offEl) offEl.hidden = true; }
      }
      if (atc) {
        if (v.available) { atc.disabled = false; atc.textContent = atc.getAttribute('data-label'); }
        else { atc.disabled = true; atc.textContent = 'אזל מהמלאי'; }
      }
      if (v.featured_media && window.OfeeleGallery) window.OfeeleGallery.goToMedia(v.featured_media.id);
      var url = new URL(window.location); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }
    wrap.addEventListener('change', function (e) { if (e.target.matches('.opt input')) update(); });
    update();
  });

  /* ---------- Gallery ---------- */
  (function () {
    var track = $('[data-gallery-track]');
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var dots = $$('[data-gallery-dot]');
    function setActive(i) { dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); }); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) setActive(slides.indexOf(en.target)); });
    }, { root: track, threshold: 0.6 });
    slides.forEach(function (s) { io.observe(s); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }); });
    window.OfeeleGallery = {
      goToMedia: function (mediaId) {
        var target = slides.find ? slides.find(function (s) { return s.getAttribute('data-media-id') == mediaId; }) : null;
        if (!target) { slides.forEach(function (s) { if (s.getAttribute('data-media-id') == mediaId) target = s; }); }
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };
  })();

  /* ---------- Sticky ATC ---------- */
  (function () {
    var bar = $('.sticky-atc');
    var anchor = $('[data-atc]');
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-60px 0px 0px 0px' });
    io.observe(anchor);
    var sbtn = $('[data-sticky-atc]');
    if (sbtn) sbtn.addEventListener('click', function () { anchor.click(); });
  })();

  /* ---------- Newsletter popup ---------- */
  (function () {
    var pop = $('#NlPopup');
    if (!pop) return;
    var KEY = 'ofeele_popup_v1';
    try { if (localStorage.getItem(KEY)) return; } catch (e) { return; }
    if (new URLSearchParams(location.search).get('customer_posted') === 'true') return;
    var shown = false;
    function show() {
      if (shown) return; shown = true;
      pop.classList.add('is-open'); document.body.style.overflow = 'hidden';
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    }
    setTimeout(show, 18000);
    var onScroll = function () {
      if (window.scrollY > document.body.scrollHeight * 0.45) { show(); window.removeEventListener('scroll', onScroll); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---------- Newsletter inline success ---------- */
  if (new URLSearchParams(location.search).get('customer_posted') === 'true') {
    $$('[data-nl-success]').forEach(function (el) { el.hidden = false; });
    var nlp = $('#NlPopup');
    if (nlp) { nlp.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  }
})();
